module.exports = __webpack_public_path__ + "media/images/lb/925-d6fbf7ff2cf57c28a3320ba68d0ffeea.svg";